import { getInProgressSurveyByBce } from '../api/digiscore-api';

export async function findRemoteDraftByBce(bceDigits, auth0User, token) {
  const bce = String(bceDigits || '').trim();
  if (!bce) return null;

  const email = auth0User?.email || '';

  try {
    const data = await getInProgressSurveyByBce(bce, email, token);

    if (!Array.isArray(data) || data.length === 0) {
      return null;
    }

    const first = data[0];

    return {
      draftId: first._id || first.draftId,
      enterpriseName: first.enterprise?.name || first.enterpriseName || null,
      bce: first.bce || bce,
      sectorCode: first.sectorCode || null,
    };
  } catch (e) {
    console.error('[findRemoteDraftByBce] API error:', e);
    return null;
  }
}